import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JiraRovoSearchConfigProviderEntryEntrypointProps } from './JiraRovoSearchConfigProviderEntry.entrypoint.types.tsx';

type JiraRovoSearchConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JiraRovoSearchConfigProviderEntryEntrypointProps,
	{} | null
>;

export const jiraRovoSearchConfigProviderEntrypoint: EntryPoint<
	JiraRovoSearchConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<JiraRovoSearchConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-jira-rovo-search-provider" */ './JiraRovoSearchConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
